import { gql } from "apollo-boost";

/* 기사 시작 */
export const ADMIN_DELIVERY_DELIVER_LIST_QUERY = gql`
  query AdminDeliveryDeliverList(
    $skip: Int!
    $take: Int
    $deliveryDeliver_id: String
  ) {
    AdminDeliveryDeliverList(
      skip: $skip
      take: $take
      deliveryDeliver_id: $deliveryDeliver_id
    ) {
      deliveryDelivers {
        id
        createdAt
        updatedAt
        state

        user {
          id
          createdAt
          updatedAt

          commonStatus
          role
          useStoreApp
          confirmed
          blocked
          avatar
          userId
          email
          phone
          name
          sex
          birthDate
          zipcode
          roadAddress
          jibunAddress
          addressDetail
        }

        orderCount
      }
      count
    }
  }
`;
export const ADMIN_DELIVERY_DELIVER_EDIT_MUTATION = gql`
  mutation AdminDeliveryDeliverEdit($id: String!, $state: String!) {
    AdminDeliveryDeliverEdit(id: $id, state: $state)
  }
`;
/* 기사 끝 */
